<section>
  <div class="row">
    <div class="col-6">
      <div class="row text-center">
        <div class="col-4">
          <app-progress-circle></app-progress-circle>
          <h5>Subject Progress</h5>
        </div>

        <div class="col-4">
          <app-progress-circle></app-progress-circle>
          <h5>Recent Accuracy</h5>
        </div>

        <div class="col-4">
          <app-progress-circle></app-progress-circle>
          <h5>Lifetime Accuracy</h5>
        </div>
      </div>
    </div>

    <div class="col-6">
      <div class="row px-5">
        <div class="col-6">
          <button class="btn btn-sm btn-outline-primary btn-block" (click)="open(content)">View Intro</button>
        </div>
        <div class="col-6">
          <a class="btn btn-sm btn-outline-warning btn-block" [routerLink]="['/student/history']">Review Flagged</a>
        </div>
      </div>
    </div>
  </div>
</section>

<div ngbAccordion class="subject-levels" [closeOthers]="true">
  <div ngbAccordionItem="lesson-1" [collapsed]="false">
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton>
        <span class="lesson-title">Lesson Title</span>
        <div class="lesson-progress">
          <ngb-progressbar [showValue]="true" type="success" [value]="25"></ngb-progressbar>
        </div>
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <table class="table">
            <thead class="thead-dark">
            <tr>
              <th scope="col">Exercise</th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col">Attempts</th>
              <th scope="col">Complete</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th scope="row"><a [routerLink]="['exercise/intro']">Exercise Title</a></th>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>#</td>
              <td><i class="fa fa-check-circle"></i></td>
            </tr>

            <tr>
              <th scope="row"><a [routerLink]="['exercise/intro']">Exercise Title</a></th>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>#</td>
              <td><i class="fa fa-check-circle"></i></td>
            </tr>

            <tr>
              <th scope="row"><a [routerLink]="['exercise/intro']">Exercise Title</a></th>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>#</td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </ng-template>
      </div>
    </div>
  </div>
  <div ngbAccordionItem="lesson-2" [collapsed]="true">
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton>
        <span class="lesson-title">Lesson Title</span>
        <div class="lesson-progress">
          <ngb-progressbar [showValue]="true" type="success" [value]="25"></ngb-progressbar>
        </div>
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <table class="table">
            <thead class="thead-dark">
            <tr>
              <th scope="col">Lesson</th>
              <th scope="col">First Score</th>
              <th scope="col">High Score</th>
              <th scope="col">Accuracy</th>
              <th scope="col">Avg. Time</th>
              <th scope="col">Attempts</th>
              <th scope="col">Complete</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th scope="row"><a [routerLink]="['exercise/intro']">Exercise Title</a></th>
              <td>## / ##</td>
              <td>## / ##</td>
              <td>##%</td>
              <td>##:##</td>
              <td>#</td>
              <td></td>
            </tr>

            <tr>
              <th scope="row"><a [routerLink]="['exercise/intro']">Exercise Title</a></th>
              <td>## / ##</td>
              <td>## / ##</td>
              <td>##%</td>
              <td>##:##</td>
              <td>#</td>
              <td></td>
            </tr>

            <tr>
              <th scope="row"><a [routerLink]="['exercise/intro']">Exercise Title</a></th>
              <td>## / ##</td>
              <td>## / ##</td>
              <td>##%</td>
              <td>##:##</td>
              <td>#</td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Subject Intro Video</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-4">
    <div class="embed-responsive embed-responsive-16by9">
      <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/VB32073N4vY" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
  </div>
</ng-template>
